// utils/starredCount.js

/**
 * Returns the number of Communication resources that are starred by a given practitioner.
 *
 * @param {Array} messages - Array of FHIR Communication resources
 * @param {string} practitionerId - FHIR Practitioner ID to check flags for
 * @returns {number} - Count of starred messages for the practitioner
 */
export const getStarredCount = (messages = [], practitionerId) => {
  if (!practitionerId) return 0;

  return messages.filter(comm => {
    return comm.extension?.some(ext => {
      if (ext.url !== "http://endpointhealth.ca/fhir/StructureDefinition/statusFlag") return false;
      const userRef = ext.extension?.find(e => e.url === "user")?.valueReference?.reference;
      const flagCode = ext.extension?.find(e => e.url === "flag")?.valueCode;
      const normalizedRef = userRef?.split("/")?.pop();
      return normalizedRef === practitionerId && flagCode === "starred";
    });
  }).length;
};